export const getDidomiNoticeId = () => {
  const regularConsentBannerId = 'CnUtpQ7h'
  const scrollConsentBannerId = 'YjTZPQHB'

  if (typeof window === 'undefined') {
    return Promise.resolve(regularConsentBannerId)
  }

  // Check user's region and continent with geolocation api.
  return (
    window
      .fetch('https://giphy.com/api/geolocation')
      .then((resp) => resp.json())
      .then(function (response) {
        if (response.region === 'CA' || response.continentCode === 'EU') {
          // User is in CA or EU, use regular consent banner notice ID.
          return regularConsentBannerId
        } else {
          // User is not in CA or EU, use scroll consent banner notice ID.
          return scrollConsentBannerId
        }
      })
      // If geolocation API check fails, use regular consent banner notice ID.
      .catch((err) => {
        console.warn(err)
        return regularConsentBannerId
      })
  )
}
